<lib-header/>

<div
  class="questions"
  [ngClass]="{
    'center-page':
      page &&
      page.questions.length &&
      (page.questions[0].answers.length === 4 ||
        page.questions[0].answers.length === 2),
    'center-page-2':
      page && page.questions.length && page.questions[0].answers.length === 1,
    'incentive-page': showInitialIncentive || showWinnerIncentive
  }"
>
  <ng-container *ngIf="isLoading">

    <ng-template #initialTemplate>
      <lib-poll-incentive
        [incentiveFlat]="incentive ?? INCENTIVE_DEFAULT"
        [drawNumber]="0"
        type="initial"
        (action)="handleIncentiveAction($event)">
      </lib-poll-incentive>
    </ng-template>

    <ng-template #winnerTemplate>
      <lib-poll-incentive
        [incentiveFlat]="incentive ?? INCENTIVE_DEFAULT"
        type="winner"
        [drawNumber]="drawNumber"
        (action)="handleIncentiveAction($event)">
      </lib-poll-incentive>
    </ng-template>


    <ng-template #endPageSuccess>
      <img
        [src]="poll.endPage.img ? poll.endPage.img : thumbsImgPath"
        [class.image-thumbs]="!poll.endPage.img"
        [alt]="poll.endPage.img ? 'IMG' : 'Thank You'"
      />
      <p class="title">{{ poll.endPage.title }}</p>
      <p class="description">{{ poll.endPage.description }}</p>
    </ng-template>

    <ng-template #endPageIncomplete>
      <img [src]="thumbsIncompleteImgPath" class="image-thumbs" alt="Incomplete reservation"/>
      <p class="title">Sua reserva não foi concluída e não será contabilizada.</p>
      <p class="description">Reserva incompleta</p>
    </ng-template>

    <ng-template #normalFlowTemplate>

      <ng-container *ngIf="page">
        <ng-container
          *ngFor="let question of page.questions; trackBy: trackByQuestionNumber"
        >
          <div class="tab">
            <p class="statement">
              {{ question.title }}
            </p>

            <div class="content">
              <ng-container
                *ngFor="
              let answer of question.answers;
              trackBy: trackByAnswerId;
              let first = first;
              let last = last;
              let answerIndex = index
            "
              >
                <ng-container *ngIf="question.type === 1">
                  <div
                    class="answer"
                    [ngClass]="{
                  active: question.value?.indexOf(answer.id) !== -1,
                  'type-2-no-img': !answer.img,
                  'two-selects': question.answers.length === 2 && !answer.img,
                  'less-three': question.answers.length < 3 && answer.img,
                  'items-three': question.answers.length === 3 && answer.img,
                  'first-select': isSatisfaction && first && question.answers.length === 2 && !answer.img,
                  'last-select': isSatisfaction && last && question.answers.length === 2 && !answer.img,
                }"
                    (click)="
                  question.value = [answer.id];
                  selectUniqueAnswer(page, answer.next)
                "
                  >
                    <ng-container *ngIf="answer.img">
                      <img [src]="answer.img" alt="IMG"/>
                    </ng-container>
                    <p class="title-answer">{{ answer.description }}</p>
                    <p *ngIf="isSatisfaction"
                       class="divider"
                       [style.background]="
                    answer.weight
                      ? colorsWithWeight[answer.weight]
                      : colorsWithWeight[answerIndex + 1]
                  "
                    ></p>
                  </div>
                </ng-container>
                <ng-container *ngIf="question.type === 2">
                  <div
                    class="answer"
                    [ngClass]="{
                  active: question.value?.indexOf(answer.id) !== -1,
                  'type-2-no-img': !answer.img,
                  'less-three': question.answers.length < 3 && answer.img,
                }"
                    (click)="
                  addAnswerType2(question, answer.id); selectUniqueAnswer(page)
                "
                  >
                    <ng-container *ngIf="answer.img">
                      <img [src]="answer.img" alt="IMG"/>
                    </ng-container>
                    <p class="title-answer">{{ answer.description }}</p>
                    <p
                      class="divider"
                      [style.background]="
                    answer.weight
                      ? colorsWithWeight[answer.weight]
                      : colorsWithWeight[answerIndex + 1]
                  "
                    ></p>
                  </div>
                </ng-container>
                <ng-container *ngIf="question.type !== 1 && question.type !== 2">
              <textarea
                [placeholder]="textAreaPlaceholder"
                [(ngModel)]="question.value"
                (ngModelChange)="
                  checkDisabled(page, true); question.value = [$event]
                "
                autofocus
              ></textarea>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showBtn">
          <div class="tab">
            <button
              class="confirm"
              (click)="selectPageAnswerNext(indexSelectedPage)"
              [disabled]="disabled"
            >
              Enviar
            </button>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!page">
        <div class="end-page">

          <ng-container
            *ngIf="pollIncomplete && isReservation; then endPageIncomplete; else endPageSuccess"/>

        </div>
      </ng-container>
      <ng-container
        *ngIf="page && page.pageNumber !== 1 && page.showTimer && page.timer"
      >
        <div class="timer">
          <p>Tempo para responder: {{ time.getValue() }} seg.</p>
        </div>
      </ng-container>
      <ng-container *ngIf="!page && poll.endPage.showTimer">
        <div class="timer">
          <p>Timer: {{ time.getValue() }} seg.</p>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="showInitialIncentive; then initialTemplate;
              else (showWinnerIncentive ? winnerTemplate : normalFlowTemplate)">
    </ng-container>

  </ng-container>

  <img class="logo-marca" [src]="logoImgPath" alt="logotipo"/>
</div>
